export default {
  // Date formatting
  'date.format': 'MM/dd/yyyy',
  'date.format_datetime': 'MM/dd/yyyy HH:mm',
  'date.format_datetime_long': "EEEE, MMMM do, yyyy 'at' h:mm a",

  cancel: 'Cancel',
  all: 'All',
  of: 'of',
  from: 'from',
  to: 'to',
  is: 'is',
  count: 'Count',
  spending: 'Spending',
  language: 'Language',
  sign_out: 'Sign out',
  sign_in: 'Sign in',
  email_address: 'Email address',
  company_name: 'Company name',
  password: 'Password',
  search: 'Search',
  entries: 'entries',
  total_budget: 'Total Budget',
  daily_budget: 'Daily',
  error: 'Error',
  deposit: 'Deposit',
  refund: 'Refund',
  withdraw: 'Withdrawal',
  amount: 'Amount',
  description: 'Description',
  unknown: 'Unknown',
  selected: 'Selected',
  nothing_found: 'Nothing found',
  type_to_search: 'Type to search...',
  'common.network_error': 'A network error occurred. Please try again.',
  'common.loading': 'Loading…',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.expired': 'Expired',
  'common.new': 'New',
  'common.choose_company': 'Choose a company',
  'data.saved': 'Data has been successfully saved',
  'data.save_failed': 'Saving the data failed: Unknown Error.',
  'data.upload_failed': 'Failed to upload file',
  'app.something_wrong': 'Something went wrong. Try again later',
  'app.init_loading': 'Preparing application',
  'app.init_failure': '{app} could not be initialized. Please try again later or contact support.',
  'brand.switcher.badge': 'Test only',
  'brand.switcher.hint': 'Testing aid: available on localhost and stage, never on production',
  'brand.switcher': 'Brand',
  'brand.colours': 'Brand colours',
  'brand.colour_primary': 'Primary',
  'brand.colour_accent': 'Accent',
  'brand.colour_remove': 'Remove this colour',
  'brand.colour_not_set': 'Not set',
  'auth.tagline': 'Intelligent job ads',
  'auth.welcome_back': 'Welcome back',
  'auth.welcome_subtitle': 'Your campaigns, creatives and applications in one place.',
  'auth.work_email': 'Work email',
  'auth.keep_signed_in': 'Keep me signed in',
  'auth.invalid_credentials': 'Invalid credentials',
  'auth.new_to_app': 'New to {app}?',
  'auth.create_account': 'Create an account',
  'sso.login.google': 'Sign in with Google',
  'sso.login.microsoft': 'Sign in with Microsoft',
  'sso.registration.google': 'Sign up with Google',
  'sso.registration.microsoft': 'Sign up with Microsoft',
  'sso.divider.login': 'or continue with email',
  'sso.divider.registration': 'or use your work email',
  'sso.callback.signing_in': 'Signing you in\u2026',
  'sso.link.title': 'Confirm it is you',
  'sso.link.lede_before':
    'An account with this address already exists. To connect your {provider} sign-in to it, enter the 6-digit code we sent to',
  'sso.link.lede_after': '. It expires in {minutes} minutes.',
  'sso.link.lede_unknown_address':
    'An account with this address already exists. To connect your sign-in to it, enter the 6-digit code we sent to that address.',
  'sso.link.code_label': 'Confirmation code',
  'sso.link.confirm': 'Confirm and sign in',
  'sso.error.sso_cancelled': 'The sign-in was cancelled. Try again, or use your email instead.',
  'sso.error.sso_invalid_state': 'The sign-in took too long or was already used. Please try again.',
  'sso.error.sso_email_not_verified':
    'This Google or Microsoft account has no verified email address. Use another account, or your email instead.',
  'sso.error.sso_account_disabled': 'Your account has been disabled. Please contact support.',
  'sso.error.sso_provider_disabled': 'Signing in with this provider is not available at the moment.',
  'sso.error.sso_invalid_origin': 'Signing in with Google or Microsoft is not available on this address.',
  'sso.error.sso_no_pending_identity': 'Your sign-in has expired. Please sign in with Google or Microsoft again.',
  'sso.error.sso_already_signed_in': 'You are already signed in. Reload the page to continue.',
  'sso.error.sso_exchange_failed': 'Google or Microsoft could not confirm the sign-in. Please try again.',
  'sso.error.sso_invalid_token': 'The sign-in could not be verified. Please try again.',
  'sso.error.sso_no_account':
    'There is no account for this Google or Microsoft address. Sign in with your email, or contact support.',
  'sso.error.sso_no_pending_link': 'Your sign-in has expired. Please sign in with Google or Microsoft again.',
  'sso.error.sso_identity_already_linked': 'This Google or Microsoft account already signs in to another account.',
  'sso.error.generic': 'The sign-in could not be completed. Please try again.',
  'auth.back_to_sign_in': '← Back to sign in',
  'auth.footer.privacy': 'Privacy Policy',
  'auth.footer.terms': 'Terms',
  'auth.footer.imprint': 'Imprint',
  'auth.panel.headline': 'Others reach 15%. {app} reaches 100%.',
  'auth.panel.headline_hriq': 'Reach 100% of your audience, not just the 15% searching.',
  'auth.panel.description':
    'Social media, job portals, popular websites. One campaign, every channel, no marketing expertise needed.',
  'auth.panel.many_more': 'many more',
  'auth.panel.stat_roles': 'roles advertised since 2018',
  'auth.panel.stat_campaigns': 'campaigns run for Swiss employers',
  'auth.panel.stat_clicks': 'clicks delivered to their job ads',
  'login.title': 'Sign in with your {app} account',
  'forgot_password.title': 'Forgot password',
  'reset_password.title': 'Reset your {app} password',
  'reset_password.reset_button': 'Request Reset Email',
  'reset_password.email_sent': 'A reset link was sent if an account is associated with that address',
  'reset_password.wrong_link': 'Wrong reset password link. Try again later',
  'login.remember_me': 'Remember me on this device',
  'login.password_placeholder': 'Your password',
  'login.no_account': "Don't have an account yet?",
  'login.sign_up': 'Sign up',
  'nav.home': 'Home',
  'nav.orders': 'Orders',
  'nav.cvanalyzer': 'CV Assistant',
  'nav.external_job_markets': 'Jobs',
  'nav.active_poolmirror_campaign': 'Portfolio Campaign',
  'nav.poolmirror_list': 'Portfolio Campaigns',
  'home.see_all_orders': 'See all orders',
  'home.see_all_orders_heading': "Let's See Your Order!",
  'home.see_all_orders_subheading': 'Here you will find all your existing orders',

  'order_creation.loader.content.title': 'Data is being loaded',
  'order_creation.loader.content.subtitle': 'Please wait while we load the necessary information.',
  // Order Creation Initial Step
  'order_creation.initial_step.main_heading': 'Where should candidates be directed?',
  'order_creation.initial_step.main_description':
    'Do you already have an online job posting? We can also create one for you – either based on a document or an existing website.',
  'order_creation.initial_step.option_direct_url_title': 'Direct URL',
  'order_creation.initial_step.option_direct_url_description': 'Your online URL',
  'order_creation.initial_step.option_file_import_title': 'File Import',
  'order_creation.initial_step.option_file_import_description': 'PDF / DOCX',
  'order_creation.initial_step.option_web_import_title': 'Web Import',
  'order_creation.initial_step.option_web_import_description': 'from URL',
  'order_creation.initial_step.option_custom_title': 'Custom',
  'order_creation.initial_step.option_custom_description': 'Design job posting',
  'order_creation.initial_step.lead_funnel_tooltip': 'Lead funnel possible',
  'order_creation.initial_step.direct_url_section_heading': 'Direct URL',
  'order_creation.initial_step.direct_url_section_description':
    'You already have an online job posting / website where candidates should be redirected directly.',
  'order_creation.initial_step.job_url_label': 'URL of the online job posting',
  'order_creation.initial_step.job_url_placeholder': 'example.com',
  'order_creation.initial_step.application_form_link': 'Link to apply form?',
  'order_creation.initial_step.apply_url_label': 'Apply URL',
  'order_creation.initial_step.apply_url_hint':
    'Where should applicants be redirected when clicking the "Apply now" button?',
  'order_creation.initial_step.no_apply_url_tooltip': 'No application URL',
  'order_creation.initial_step.file_import_section_heading': 'File Import',
  'order_creation.initial_step.file_import_section_description':
    'Upload a PDF or DOCX document from which the content should be imported.',
  'order_creation.initial_step.file_upload_text': 'Upload File',
  'order_creation.initial_step.web_import_section_heading': 'Web Import',
  'order_creation.initial_step.web_import_section_description':
    'We create a new online job posting based on an existing one. This allows you to create a funnel job posting, for example.',
  'order_creation.initial_step.custom_section_heading': 'Custom',
  'order_creation.initial_step.custom_section_description': 'Create a new job posting with our editor.',
  'order_creation.initial_step.content_generation_switch_label': 'Generate sample content',
  'order_creation.initial_step.content_generation_switch_description':
    'We generate an initial job posting for you based on the key details of the position.',

  // Order Creation Import Step
  'order_creation.import_step.processing_title': 'Content is being processed',
  'order_creation.import_step.processing_description':
    'Your content is currently being imported and structured. This may take a few minutes. Please be patient.',
  'order_creation.import_step.direct_link_failed': 'An error occurred while processing the link',
  'order_creation.import_step.processing_failed':
    'Something went wrong while processing. Insert data manually or try again.',

  // Order Creation Job Details Step
  'order_creation.details_step.main_heading': 'Job Details',
  'order_creation.details_step.description': 'Please check and complete the details of your posting.',
  'order_creation.details_step.basic_heading': 'General',
  'order_creation.details_step.job_title': 'Job Title',
  'order_creation.details_step.job_title_placeholder': 'ex. Senior Marketing Manager',
  'order_creation.details_step.job_title_hint': 'The full job title, <b>without</b> company or location.',
  'order_creation.details_step.workload': 'Workload',
  'order_creation.details_step.full_time': 'Full-time',
  'order_creation.details_step.part_time': 'Part-time',
  'order_creation.details_step.permanent_employment': 'Permanent',
  'order_creation.details_step.temporary_employment': 'Temporary',
  'order_creation.details_step.permanent_employment_description': 'Is it a permanent position (permanent employment)?',
  'order_creation.details_step.temporary_employment_description': 'Is this a temporary job?',
  'order_creation.details_step.company_heading': 'Company',
  'order_creation.details_step.company_title': 'Company',
  'order_creation.details_step.company_placeholder': 'Choose a company',
  'order_creation.details_step.location_title': 'Location',
  'order_creation.details_step.address': 'Address',
  'order_creation.details_step.use_company_address': 'Use company address',
  'order_creation.details_step.location_hint':
    'If enabled, the company location will be used as the workplace location.',
  'order_creation.details_step.job_title_required': 'Job Title is required.',
  'order_creation.details_step.workload_min_must_be_smaller_or_equal_max':
    'Minimum workload must be smaller than or equal to maximum workload.',
  'order_creation.details_step.company_required': 'Company is required.',
  'order_creation.details_step.upload_logo': 'Upload logo',
  'order_creation.details_step.remove_logo': 'Remove logo',
  'order_creation.details_step.address_required': 'Address is required.',
  'order_creation.details_step.no_active_budget_title': 'No active budget',
  'order_creation.details_step.no_active_budget_description':
    'You currently have no active budget, so a new order cannot be created. Please contact support to set up a budget.',

  // Order Creation Media Step
  'order_creation.media_step.main_heading': 'Media',
  'order_creation.media_step.description': 'Which media should be used for the job posting and the ads?',
  'order_creation.media_step.for_this_order': 'For this order',
  'order_creation.media_step.upload_image': 'Upload image',
  'order_creation.media_step.uploading': 'Uploading…',
  'order_creation.media_step.imported_from_source': 'Imported from source',
  'order_creation.media_step.imported_from_source_desc': 'Images that were found in connection with your source.',
  'order_creation.media_step.imported_from_source_loading': 'Looking for images…',
  'order_creation.media_step.imported_from_source_empty': 'No images were found for your source.',
  'order_creation.media_step.imported_from_source_error':
    'We could not load images for your source. Please try again later.',
  'order_creation.media_step.company_images': 'Company images',
  'order_creation.media_step.company_images_desc': 'Images that are associated with the company you selected.',
  'order_creation.media_step.add': 'Add',
  'order_creation.media_step.ai_media': 'AI Media',
  'order_creation.media_step.ai_media_desc':
    "You don't have images? We can generate AI-based media suggestions for you based on the content of your job posting.",
  'order_creation.media_step.generate_more': 'generate more',
  'order_creation.media_step.focus_update_success': 'Focus point updated',
  'order_creation.media_step.focus_update_failed': 'Failed to update focus point. Please try again.',

  // Order Creation Publication Steps
  'order_creation.publication_type.title': 'Publication Type',
  'order_creation.publication_type.subtitle': 'What type of publication would you like to create?',
  'order_creation.publication_type.online.title': 'Application form',
  'order_creation.publication_type.online.hint': 'Form with CV upload',
  'order_creation.publication_type.funnel.title': 'Funnel',
  'order_creation.publication_type.funnel.hint': 'Lead Funnel',
  'order_creation.publication_type.settings': 'Funnel Settings',
  'order_creation.publication_type.settings_hint': 'Please select the desired funnel options.',
  'order_creation.publication_type.content_settings': 'Content Settings',
  'order_creation.publication_type.content_settings_hint': 'Please select the desired content options.',
  'order_creation.publication_type.optimize_title': 'Optimize Content for Funnel',
  'order_creation.publication_type.optimize_hint':
    'We can automatically rewrite the content of your job posting for a funnel or lead campaign for you.',
  'order_creation.publication_type.optimize_content_title': 'Optimize Content',
  'order_creation.publication_type.optimize_content_hint':
    'We can automatically rewrite and improve the content of your job posting for you.',
  'order_creation.publication_type.questions_title': 'Generate Qualification Questions',
  'order_creation.publication_type.questions_hint':
    "We generate 3–4 qualification questions based on your job posting. For example: If a requirement is a driver's license of a certain category, this can be automatically queried here.",
  'order_creation.publication_type.contact.title': 'Contact',
  'order_creation.publication_type.contact.subtitle':
    'Who should receive email notifications about new applications / contacts?',
  'order_creation.publication_type.contact.label': 'Publication Contact',
  'order_creation.publication_type.contact.placeholder': 'Select users',

  // Order Creation Publication Template Steps
  'order_creation.publication_template.title': 'Publication Template',
  'order_creation.publication_template.subtitle': 'How should the online publication look?',
  'order_creation.publication_template.loading.title': 'Publication is being created',
  'order_creation.publication_template.loading.subtitle': 'Please wait a moment, your publication is being created.',
  'order_creation.publication_template.no_templates.title': 'No templates available',
  'order_creation.publication_template.no_templates.subtitle':
    'There are no publication templates available for this order. Please contact support to continue.',

  // Order Creation Final Review Step
  'order_creation.final_review.title': 'Your Order',
  'order_creation.final_review.subtitle':
    'Everything is now ready for your order. You can either confirm it immediately or generate a link to request confirmation.',
  'order_creation.final_review.basic_data': 'Basic Data',
  'order_creation.final_review.online_link': 'Online Link',
  'order_creation.final_review.advertising_preview': 'Advertising Preview',
  'order_creation.final_review.products': 'Products',
  'order_creation.final_review.start_button': 'Start Order',
  'order_creation.final_review.confirm_now.title': 'Confirm Now',
  'order_creation.final_review.confirm_now.subtitle': 'The order will be confirmed immediately.',
  'order_creation.final_review.confirm_external.title': 'External Confirmation',
  'order_creation.final_review.confirm_external.subtitle': 'Generate a link for confirmation.',
  'order_creation.final_review.reference_comment.title': 'Reference & Comment',
  'order_creation.final_review.reference_comment.ref_number_label': 'Reference number (optional)',
  'order_creation.final_review.reference_comment.ref_number_hint':
    'A reference to identify the order, e.g. from your internal system.',
  'order_creation.final_review.reference_comment.comment_label': 'Comment (optional)',
  'order_creation.final_review.reference_comment.comment_hint':
    'Wishes or additional information for our campaigning team.',

  // Order Creation Confirmation Step
  'order_creation.confirmation.page_title': 'Order confirmation',
  'order_creation.confirmation.title': 'Your order is placed!',
  'order_creation.confirmation.subtitle.self_service': 'Your campaign is being set up and will go live shortly.',
  'order_creation.confirmation.subtitle.managed': 'Our team will review your order and confirm it shortly.',
  'order_creation.confirmation.order_id': 'Order ID',
  'order_creation.confirmation.job_title': 'Job title',
  'order_creation.confirmation.company': 'Company',
  'order_creation.confirmation.total': 'Total',
  'order_creation.confirmation.campaign_start': 'Campaign start',
  'order_creation.confirmation.preview_link': 'Preview Link',
  'order_creation.confirmation.copy': 'Copy',
  'order_creation.confirmation.copied': 'Copied!',
  'order_creation.confirmation.view_order': 'View order',
  'order_creation.confirmation.place_another': 'Place another order',

  // Order Creation Self Service Step
  'order_creation.loader.stage.banners': 'Banners',
  // shown while job.generate_banners is still running — campaign generation is queued behind it
  'order_creation.loader.banners.1.title': 'Designing your banners',
  'order_creation.loader.banners.1.subtitle': 'Every pixel in its place.',
  'order_creation.loader.banners.2.title': 'Rendering the video banners',
  'order_creation.loader.banners.2.subtitle': 'This is the slow, pretty part.',
  'order_creation.loader.banners.3.title': 'Picking the right crops',
  'order_creation.loader.banners.3.subtitle': 'Nobody likes a cut-off headline.',
  'order_creation.loader.banners.4.title': 'Almost through the artwork',
  'order_creation.loader.banners.4.subtitle': 'The campaigns are up next.',
  'order_creation.loader.campaigns.1.title': 'Spinning up the campaigns',
  'order_creation.loader.campaigns.1.subtitle': 'The gears are turning.',
  'order_creation.loader.campaigns.2.title': 'Warming up the ad engines',
  'order_creation.loader.campaigns.2.subtitle': 'They run smoother after a moment.',
  'order_creation.loader.campaigns.3.title': 'Rolling out the digital red carpet',
  'order_creation.loader.campaigns.3.subtitle': 'Your campaigns deserve a proper entrance.',
  'order_creation.loader.campaigns.4.title': 'Wrangling the campaigns into shape',
  'order_creation.loader.campaigns.4.subtitle': 'They can be surprisingly shy.',
  'order_creation.loader.campaigns.5.title': 'Unfolding the billboards',
  'order_creation.loader.campaigns.5.subtitle': 'Metaphorically, of course.',
  'order_creation.loader.campaigns.6.title': 'Teaching the algorithms to behave',
  'order_creation.loader.campaigns.6.subtitle': 'Usually they listen.',
  'order_creation.loader.campaigns.7.title': 'Polishing the banners',
  'order_creation.loader.campaigns.7.subtitle': 'A little shine goes a long way.',

  'home.see_all_poolmirror': 'See Campaign',
  'home.see_all_poolmirror_heading': 'Your Portfolio Campaign',
  'home.see_all_poolmirror_subheading': 'Your Portfolio Slot Subscription with Utilization and Campaigns at a Glance.',
  'home.create_order': 'Create an order',
  'home.create_order_heading': "Don't have an order yet?",
  'home.create_order_subheading': 'Give your job posting a boost.',
  'order_creation_blocked.title': "You can't place an order yet",
  'order_creation_blocked.body':
    "Oops, something went wrong with your account setup, so campaigns can't be created right now. Contact support and we'll sort this out quickly.",
  'portfolio.list_poolmirror': 'All Portfolio Campaigns',
  'portfolio.crawled_jobs': 'Crawled jobs',
  'portfolio.campaign_slots': 'Campaign slots',
  'portfolio.slot_usage': 'Slot usage',
  'portfolio.subscription': 'Subscription',
  'portfolio.subscription_ends_in': 'ends',
  'portfolio.subscription_ended': 'ended',
  'portfolio.available_jobs': 'Available jobs',
  'portfolio.show_all_slots': 'Show all available slots',
  'portfolio.job_search_placeholder': 'Press "/" to search for jobs',
  'search.generic_placeholder': 'Press "/" to search',
  'orders.search_placeholder': 'Search orders, job IDs, companies...',
  'cvanalyzer.list.title': 'Analyzed CVs',
  'is_loading.generic': 'Loading data...',
  'sort.direction': 'Sort direction',
  'sort.field.relevance': 'Relevance',
  'sort.field.created_at': 'Created at',
  'orders.list.sort.title': 'Order title',
  'orders.list.column.order': 'Order',
  'orders.list.column.runtime': 'Runtime',
  'orders.list.column.budget': 'Budget',
  'orders.grid.last_7_days': 'Last 7 days',
  'orders.grid.clicks_ctr': 'Clicks · CTR',
  'orders.details.open': 'Open',
  'btn.more': 'More',
  'orders.layout.list': 'List',
  'orders.layout.grid': 'Grid',
  'orders.list.title': 'Orders',
  'orders.list.title.company': '{company} orders',
  'orders.list.subtitle.singular': 'order',
  'orders.list.subtitle.plural': 'orders',
  'orders.list.loading': 'Loading your orders..',
  'orders.list.filter_label': 'Filter',
  'orders.list.filter_all': 'All',
  'orders.list.filter_active': 'Active',
  'orders.list.filter_drafts': 'Drafts',
  'orders.list.filter_past': 'Past orders',
  'orders.list.filter_my': 'Mine',
  'orders.list.empty': 'No orders found',
  'orders.list.empty.hint': "Try adjusting your search or filter to find what you're looking for.",
  'orders.list.empty.active.title': 'No active orders, yet',
  'orders.list.empty.active.body':
    'Your next hire is one order away. Start a new one, or pick up a draft or past order in All.',
  'orders.list.empty.active.go_to_all': 'Go to All',
  'orders.create': 'Create order',
  'orders.create.empty.header': 'Access Denied',
  'orders.create.empty.title': 'Oops... You have no access to this feature',
  'orders.create.empty.subtitle': 'Try contacting your administrator to grant you access to this feature.',
  'orders.create_button': 'Create an order',
  'orders.list.total_clicks': 'Total Clicks',
  'orders.list.impressions': 'Impressions',
  'orders.list.days': 'Days',
  'orders.list.worldwide': 'Worldwide',
  'orders.pagination.page': 'Page',
  'orders.pagination.prev': 'Previous',
  'orders.pagination.next': 'Next',
  'pagination.of': 'of',
  'pagination.nav': 'Pagination',
  'pagination.first': 'First page',
  'pagination.prev': 'Previous page',
  'pagination.next': 'Next page',
  'pagination.last': 'Last page',
  'orders.filters.list_style': 'List Style',
  'orders.filters.time_range': 'Time Range',
  'orders.filters.company_name': 'Company Name',
  'orders.filters.creator': 'Creator',
  'orders.filters.location': 'Workspace location',
  'orders.filters.language': 'Language',
  'language.de': 'German',
  'language.en': 'English',
  'language.fr': 'French',
  'language.it': 'Italian',
  'orders.filters.reset_filters': 'Reset filters',
  'orders.filters.apply': 'Apply',

  'orders.filters.everything': 'Everything',
  'orders.filters.today': 'Today',
  'orders.filters.thisWeek': 'This Week',
  'orders.filters.thisMonth': 'This Month',
  'orders.filters.thisYear': 'This Year',
  'orders.filters.last7': 'Last 7 days',
  'orders.filters.last30': 'Last 30 days',
  'orders.filters.last90': 'Last 90 days',

  'btn.close': 'Close',
  'btn.cancel': 'Cancel',
  'btn.confirm': 'Confirm',
  'btn.confirmed': 'Confirmed',
  'btn.continue': 'Continue',
  'btn.save': 'Save',
  'btn.save_and_continue': 'Save & Continue',
  'btn.add': 'Add',
  'btn.back': 'Back',
  'btn.delete': 'Delete',
  'btn.edit': 'Edit',
  'btn.synchronize': 'Synchronize',
  'btn.add_location': 'Add location',
  'btn.generate_link': 'Generate Link',
  'btn.add_more': 'Add more',
  'btn.select': 'Select',
  'app.saving': 'Saving...',
  'app.saved': 'Saved',
  'app.save_error': 'Error while saving',
  'app.unsaved_changes': 'You have unsaved changes',
  'app.all_changes_saved': 'All changes saved',
  'common.message': 'Message',
  'common.step': 'Step',
  'common.of': 'of',
  'common.close': 'Close',
  'customer.cards.settings.title': 'Box settings',
  'customer.cards.settings.metric_label': 'Metric',
  'customer.cards.settings.metric_placeholder': 'Please choose...',
  'common.comment': 'Comment',
  'common.done': 'Done',
  'common.workspace': 'Workspace',
  'common.company': 'Company',
  'common.title': 'Title',
  'common.job': 'Job',
  'common.dates': 'Dates',
  'common.duration': 'Duration',
  'common.impressions': 'impressions',
  'common.clicks': 'clicks',
  'datepicker.startdate': 'Start date',
  'datepicker.select_start': 'Select campaign start',
  'datepicker.date_help': 'Please specify how long you want your campaign to run',
  'datepicker.date_help.only_start': 'Please specify when the campaign should start',
  'datepicker.days': 'Days',
  'datepicker.infinite_duration': 'Infinite',
  'dropzone.drop_browse': 'Drop or browse files',
  'dropzone.drop_msg': 'Drop the files',

  'campaigns.manual.location_limit_reached': 'Remove a location to add a different one.',
  'campaigns.manual.add_address': 'Add another address',
  'campaigns.manual.search_address': 'Search for an address',
  'campaigns.manual.max_file_size': 'max {size} KB',
  'campaigns.status.new': 'New',
  'campaigns.status.confirmed': 'Confirmed',
  'campaigns.status.sync': 'Syncing',
  'campaigns.status.active': 'Active',
  'campaigns.status.paused': 'Paused',
  'campaigns.status.error': 'Error',
  'campaigns.status.finished': 'Finished',
  'campaigns.please_select': 'Please select...',
  'campaigns.please_write': 'Please write...',
  'campaigns.no_campaigns': 'There are no campaigns yet for this order.',
  'campaigns.contact_support': 'Please contact our support for more information.',
  'campaigns.self_service.continue_blocked_incomplete':
    'You can’t continue yet. Please fill in all mandatory fields and save every card of every campaign.',
  'campaigns.self_service.continue_blocked_contact_support':
    'All campaign cards are saved, but the order still can’t be continued. Please contact our support.',
  'campaigns.no_banners_found': 'No banners found.',
  'campaigns.click_to_upload': 'Click to upload image',
  'campaigns.choose_image': 'Choose an image',
  'campaigns.choose_video': 'Choose a video',
  'campaigns.media.video_banner': 'Video Banner',
  'campaigns.media.video_processing': 'The video is still being processed and there is no preview yet',
  'campaigns.media.video_failed': 'The video failed to process',
  'campaigns.media.banner_processing': 'Banner is being processed',
  'campaigns.media.banner_failed': 'Banner failed to render',
  'campaigns.please_fill_in': 'Please fill in all fields before saving.',
  'campaigns.please_select_location': 'Please select a location...',
  'campaign.error_saving': 'There was an error saving the updated fields. Please try again.',
  'campaigns.adform.remove_creative': 'Remove creative',
  'campaigns.linkedin.linkedin_job_advertisement': 'LinkedIn Job Advertisement',
  'campaigns.linkedin.linkedin_description': `Connect your LinkedIn company page and define key job details like employment type, workplace setting
      (remote,
      hybrid, on-site), and contract status to tailor your listing for the right candidates.`,
  'campaigns.linkedin.open_in_linkedin': 'Open in LinkedIn',
  'campaigns.linkedin.linkedin_profile_hint':
    'Please Select the Linkedin Company Profile this Job should be published on.',
  'campaigns.linkedin.linkedin_profile_description': 'Select the LinkedIn Company Page for this Job',
  'campaigns.linkedin.error_saving_page': 'There was an error saving the LinkedIn Company Page. Please try again.',
  'campaigns.linkedin.please_select_location': 'Select the location where the job is based.',
  'campaigns.linkedin.error_saving_location': 'There was an error saving the LinkedIn Location. Please try again.',
  'campaigns.linkedin.terms_and_conditions': 'Terms & Conditions',
  'campaigns.linkedin.i_agree': 'I agree to the',
  'campaigns.linkedin.terms_and_conditions_part': 'terms and conditions',
  'campaigns.linkedin.terms_and_conditions_error': 'You must agree to the terms and conditions before proceeding.',
  'campaigns.facebook.no_fb_pages_message':
    'There are no Facebook Pages set up, please go to Settings -> Linked Social Networks to connect to your Facebook page.',
  'campaigns.facebook.facebook_ad_story_error':
    'You forgot to select an image for your story format. Please select an image or remove the story format placement.',
  'campaigns.facebook.select_facebook_page_first': 'Select Facebook Page first',
  'campaigns.facebook.failed_retrieving_targeting_data': 'Failed to retrieve targeting data. Try again later.',
  'campaigns.facebook.location_targeting': 'Location Targeting',
  'campaigns.facebook.add_location': 'Add Location',
  'campaigns.facebook.choose_country': 'Choose a country',
  'campaigns.facebook.choose_location': 'Choose a location',
  'campaigns.facebook.radius_tooltip': 'Optional: Between 17 and 80 (kilometers)',
  'campaigns.facebook.radius_unavailable_for_region': 'Radius is not available for regions',
  'campaigns.facebook.radius_choose_country_first': 'Choose a country first to set a radius.',
  'campaigns.facebook.targeting_level_label': 'Targeting level',
  'campaigns.facebook.targeting_level_country': 'Country',
  'campaigns.facebook.targeting_level_location': 'City / Region',
  'campaigns.facebook.location_country_required': 'Choose a country for this location.',
  'campaigns.facebook.location_required': 'Choose a city or region, or switch this location to Country.',
  'campaigns.facebook.location_radius_range': 'The radius must be between 17 and 80 kilometers.',
  'campaigns.facebook.locations_incomplete': 'Some locations are incomplete.',
  'campaigns.facebook.locations_save_failed': 'The locations could not be saved. Check them and try again.',
  'campaigns.facebook.primary_texts': 'Primary Texts',
  'campaigns.facebook.add_primary_text': 'Add Primary Text',
  'campaigns.facebook.image_selection': 'Image Selection',
  'campaigns.facebook.toast_info': `You must have a story format if you're using multiple primary texts. Please add a story format or remove extra primary texts.`,
  'campaigns.facebook.remove_portrait_format': 'Remove portrait format',
  'campaigns.google_ads.headlines': 'Headlines',
  'campaigns.google_ads.descriptions': 'Descriptions',
  'campaigns.google_ads.headline_count': '{current} / {max} headlines',
  'campaigns.google_ads.description_count': '{current} / {max} descriptions',
  'campaigns.google_ads.logo_image': 'Logo image',
  'campaigns.google_ads.marketing_images': 'Marketing Images',
  'campaigns.google_ads.images_used': 'images used',
  'campaigns.google_ads.location': 'Location',
  'campaigns.google_ads.radius': 'Radius',
  'campaigns.tiktok.ad_text': 'Ad Text',
  'campaigns.tiktok.video': 'Video',
  'campaigns.tiktok.select_video': 'Select video',
  'campaigns.tiktok.interest_categories_placeholder': 'Select interest categories',
  'campaigns.tiktok.remove_ad': 'Remove ad',

  'orders.create.wizard': 'Wizard',
  'orders.create.form.disabled': 'Publication URL required',
  'orders.create.full_form': 'Full-form',
  'orders.create.btn': 'New order',
  'orders.create.title_create': 'Create new order',
  'orders.create.title_modify': 'Modify and create new order',
  'orders.create.title_confirm': 'Please confirm your new order',
  'orders.wizard.intro.heading': 'Hi there',
  'orders.wizard.intro.subheading':
    "Let me help you to create your programmatic order. I'm still learning, but I will try to help you gather the required information and analyze your data.",
  'orders.wizard.intro.job_posting': 'your job posting',
  'orders.wizard.steps.apply_link': 'You have an apply link?',
  'orders.wizard.steps.url': 'Online Publication URL',
  'orders.wizard.steps.apply_url': 'Apply URL',
  'orders.wizard.intro.new_posting_title': 'Or a new publication',
  'orders.wizard.intro.new_posting_description':
    "If you don't have a link to an online job publication, you can also create one via {app}. You can upload a PDF or Word document, for example.",
  'orders.wizard.intro.new_posting_button': 'Create online job publication',
  'orders.wizard.intro.url_enter': 'Enter the URL of your job posting.',
  'orders.wizard.intro.url_help':
    'The page behind this URL should exclusively contain the job posting you are trying to promote.',
  'orders.wizard.intro.apply_url_enter': 'Enter the apply URL of your job posting.',
  'orders.wizard.intro.apply_url_help':
    "Where the applicants should be redirected to if they click on the 'Apply now' call to action button.",

  'orders.wizard.products.title': 'Product Selection',
  'orders.wizard.products.loading_budget': 'Loading Budget...',
  'orders.wizard.products.loading_budget.description': 'Please wait while we load the available budget.',
  'orders.wizard.products.no_products': 'No Products Available',
  'orders.wizard.products.no_products.description':
    "You can't proceed without selecting at least one product. Contact your manager",
  'orders.wizard.products.products': 'Products',
  'orders.wizard.products.product': 'Product',
  'orders.wizard.products.recommended': 'Recommended',
  'orders.wizard.products.key_data': 'Key Data',

  'orders.wizard.platforms.title': 'Platform Selection',
  'orders.wizard.platforms.subtitle':
    'Where should we publish your job posting? Please select the platforms you want to use.',
  'orders.wizard.platforms.platforms': 'Platforms',

  'orders.wizard.analytics.title': 'Analysing Job Data',
  'orders.wizard.analytics.subtitle':
    'We are currently analysing your online job posting. This can take a few seconds to complete...',
  'orders.wizard.analytics.subtitle_completed': 'Job posting was successfully analysed.',
  'orders.wizard.analytics.campaign_duration': 'Campaign Duration',
  'orders.wizard.analytics.campaign_budget': 'Campaign Budget',

  'orders.wizard.analytics.total_budget': 'Total Budget',
  'orders.wizard.analytics.daily': 'Daily',
  'orders.wizard.analytics.budget_help':
    'Please specify the budget for your campaign. With a minimum running time of {duration} days, the minimum budget is {min_budget}',
  'orders.wizard.analytics.analyzing': 'Analyze',
  'orders.wizard.analytics.crawling': 'Crawling job posting',
  'orders.wizard.analytics.connecting': 'Connecting to Robot',
  'orders.wizard.analytics.failed_to_retrieve': 'Failed to retrieve',
  'orders.wizard.analytics.document_open': 'Opening document',
  'orders.wizard.analytics.validating_format': 'Validating document format...',
  'orders.wizard.analytics.extracting_metadata': 'Extracting metadata...',
  'orders.wizard.analytics.parsing_content': 'Parsing content...',
  'orders.wizard.analytics.identifying_job_title': 'Identifying job title...',
  'orders.wizard.analytics.extracting_workload': 'Extracting workload...',
  'orders.wizard.analytics.detecting_workplace': 'Detecting workplace...',
  'orders.wizard.analytics.analyzing_requirements': 'Analyzing requirements...',
  'orders.wizard.analytics.extracting_responsibilities': 'Extracting responsibilities...',
  'orders.wizard.analytics.formatting_publication': 'Formatting job posting...',
  'orders.wizard.analytics.optimizing_output': 'Optimizing output...',
  'orders.wizard.analytics.finalizing_publication': 'Finalizing job posting...',
  'orders.wizard.details.title': 'Job Details',
  'orders.wizard.details.subtitle': 'Please check and complete details of your posting.',
  'orders.wizard.details.job_title': 'Job title / position',
  'orders.wizard.details.job_title_help':
    "Provide your job title. Ideally without the workload '80-100%'. Try to keep it short and concise as space is limited.",
  'orders.wizard.details.company_name': 'Company name',
  'orders.wizard.details.company_name_help':
    'The name of the company hiring the position. This will be displayed publicly.',
  'orders.wizard.details.workload_min': 'Workload min',
  'orders.wizard.details.workload_max': 'Workload max',
  'orders.wizard.details.location': 'Workplace location',
  'orders.wizard.details.location_help':
    'The location of the workplace. This will be displayed publicly and used for geotargeting in some cases.',

  'orders.wizard.media.title': 'Media',
  'orders.wizard.media.subtitle': 'Optionally, upload your company logo for this order',
  'orders.wizard.media.images_subtitle': 'Optionally, upload additional images for this order',
  'orders.wizard.media.company_logo': 'Company logo',
  'orders.wizard.media.order_images': 'Order Images',
  'orders.wizard.media.use_logo_future': 'Use the logo for the future',

  'orders.wizard.remarks.title': 'Remarks',
  'orders.wizard.remarks.subtitle':
    'Let us know if you have any special requests or remarks. We will get back to you as soon as possible.',
  'orders.wizard.remarks.msg_placeholder': 'Please do...',

  'publication.editor.title': 'Edit publication',
  'publication.editor.tabs.meta': 'Meta',
  'publication.editor.tabs.template': 'Template',
  'publication.editor.tabs.settings': 'Settings',
  'publication.editor.tabs.form': 'Form',
  'publication.editor.tabs.questions': 'Questions',
  'publication.editor.meta.name': 'Name',
  'publication.editor.meta.active': 'Active',
  'publication.editor.meta.active.hint': 'Publication is publicly accessible',
  'publication.editor.meta.template': 'Template',
  'publication.editor.meta.variation': 'Variation',
  'publication.editor.meta.pubkey': 'Pubkey',
  'publication.editor.meta.created': 'Created',
  'publication.editor.meta.updated': 'Last updated',
  'publication.editor.meta.open_public_url': 'Open Public URL',
  'publication.editor.update_success': 'Publication was updated',
  'publication.editor.update_failed': 'Failed to update publication',
  'publication.editor.template': 'Current Template',
  'publication.editor.template.hint':
    "Choose a template that best fits your job's audience for optimal results. Keep in mind that changing the template will reset all your settings, but your content will remain intact.",
  'publication.editor.contact_method': 'Candidate contact method',
  'publication.editor.contact_method.description': 'Choose which contact details candidates must provide and verify.',
  'publication.editor.contact_method.email': 'Email only',
  'publication.editor.contact_method.phone': 'Phone only',
  'publication.editor.contact_method.both': 'Email and phone',
  'publication.editor.no_settings': 'No settings found',

  // template adjustments (saved, reusable option values)
  'publication.editor.adjustments.save_title': 'Save these settings for reuse?',
  'publication.editor.adjustments.save_description':
    'Choose which settings to keep as a default for future publications.',
  'publication.editor.adjustments.persist_all': 'All future publications',
  'publication.editor.adjustments.persist_once': 'Only this time',
  'publication.editor.adjustments.select_all': 'Select all',
  'publication.editor.adjustments.deselect_all': 'Deselect all',
  'publication.editor.adjustments.close': 'Close',
  'publication.editor.adjustments.name_label': 'Name',
  // {n} is replaced with the next free number; the placeholder shows what an unnamed save will be called
  'publication.editor.adjustments.default_name': 'Adjustment {n}',
  'publication.editor.adjustments.name_optional_hint': 'Optional — leave empty to use the suggested name.',
  'publication.editor.adjustments.save_and_continue': 'Save & continue',
  'publication.editor.adjustments.continue_without_saving': 'Continue without saving',
  'publication.editor.adjustments.save_success': 'Adjustment saved.',
  'publication.editor.adjustments.save_error': 'Could not save the adjustment.',
  'publication.editor.adjustments.load_title': 'Load saved settings?',
  'publication.editor.adjustments.load_description':
    'We found saved settings for this company. Load one as a starting point?',
  'publication.editor.adjustments.load_description_single':
    'We found a saved adjustment for this company. Load it as a starting point?',
  'publication.editor.adjustments.load': 'Load',
  'publication.editor.adjustments.start_from_defaults': 'Start from defaults',
  'publication.editor.adjustments.preview_title': 'Values that will be applied',
  'publication.editor.adjustments.no_value': '(empty)',
  'publication.editor.adjustments.value_yes': 'Yes',
  'publication.editor.adjustments.value_no': 'No',
  'publication.editor.adjustments.delete_confirm_title': 'Delete saved adjustment?',
  'publication.editor.adjustments.delete_confirm_description':
    'This removes the saved adjustment. Publications already created from it are not affected.',
  'publication.editor.adjustments.load_success': 'Saved settings applied.',
  'publication.editor.adjustments.delete_success': 'Adjustment deleted.',
  'publication.editor.adjustments.delete_error': 'Could not delete the adjustment.',
  'publication.editor.resize': 'Drag to resize',
  'publication.editor.device.label': 'Preview device',
  'publication.editor.device.mobile': 'Mobile',
  'publication.editor.device.tablet': 'Tablet',
  'publication.editor.device.desktop': 'Desktop',
  'publication.editor.mode.label': 'View mode',
  'publication.editor.fullscreen.label': 'Fullscreen',
  'publication.editor.fullscreen.open': 'Open fullscreen preview',
  'publication.editor.fullscreen.close': 'Close fullscreen preview',
  'publication.editor.save_failed': 'Save failed',
  'publication.editor.saved': 'Saved',
  'publication.editor.transforming_content': 'Preparing content…',
  'publication.editor.optimizing_content': 'Generating content…',
  'publication.editor.mode.editor': 'Editor',
  'publication.editor.mode.preview': 'Preview',
  'publication.editor.preview_button': 'Funnel preview',
  'publication.editor.select_placeholder': 'Select...',
  'publication.editor.please_select': 'Please select...',
  'publication.editor.items': 'Items',
  'publication.editor.item': 'Item',
  'publication.editor.add_item': 'Add item',
  'publication.editor.no_items': 'No items added yet.',
  'publication.editor.no_items_hint': 'No items added yet. Click "Add item" to get started.',
  'publication.editor.image.change': 'Change',
  'publication.editor.image.clear': 'Clear',
  'publication.editor.image.invalid_file': 'Please select a valid image file.',
  'publication.editor.image.too_large': 'Image is too large. Maximum size is 10MB.',
  'publication.editor.image.missing_hash': 'Upload succeeded but no image hash was returned.',
  'publication.editor.image.upload_failed': 'Failed to upload image. Please try again.',
  'publication.editor.image.company_images': 'Company images',
  'publication.editor.image.no_company_images': 'No company images available for this order.',
  'publication.editor.image.upload': 'Upload or choose from library',
  'publication.editor.email_role_badge.label': 'Also used in emails',
  'publication.editor.email_role_badge.tooltip': 'This is also used as the {role} in the candidate confirmation email.',
  'publication.editor.email_role_badge.role.header': 'header image',
  'publication.editor.email_role_badge.role.logo': 'logo',
  'publication.editor.email_role_badge.role.accent': 'accent color',
  'publication.editor.template_changed_success': 'Template changed successfully',
  'publication.editor.template_change_failed': 'Failed to change template',
  'publication.editor.change_template.title': 'Change Template',
  'publication.editor.change_template.description':
    "Changing the template will reset all settings, content won't be affected. This action cannot be undone. Are you sure you want to continue?",

  'form.questions.title': 'Qualification questions',
  'form.questions.description': 'Choose what candidates answer when they apply.',
  'form.questions.add_new': 'Add question',
  'form.questions.loading': 'Loading questions...',
  'form.questions.empty_title': 'What would you like to know?',
  'form.questions.empty_description': 'Add a question about experience, skills or availability.',
  'form.questions.reorder_hint': 'Drag the handle to reorder questions.',
  'form.questions.edit_description': 'Write your question and choose how candidates can answer.',
  'form.questions.save_question': 'Save question',
  'form.questions.generate_answers': 'Suggest answers with AI',
  'form.questions.ai_hint':
    'Optional. Uses your question to suggest an answer format and content. Replaces the current draft answers.',
  'form.questions.title_placeholder': 'e.g. How much experience do you have?',
  'form.questions.title_required': 'Please enter a question.',
  'form.questions.answer_type': 'Answer type',
  'form.questions.type_single_hint': 'Candidates choose one answer.',
  'form.questions.type_multiple_hint': 'Candidates can choose several answers.',
  'form.questions.type_text_hint': 'Candidates write their answer in their own words.',
  'form.questions.answer': 'Answer',
  'form.questions.remove_answer': 'Remove answer',
  'form.questions.cancel': 'Cancel',
  'form.questions.load_error': 'Failed to load questions.',
  'form.questions.reorder_success': 'Order saved.',
  'form.questions.reorder_failed': 'Failed to save order.',
  'form.questions.saved': 'Question saved.',
  'form.questions.created': 'Question created.',
  'form.questions.save_failed': 'Failed to save question.',
  'form.questions.deleted': 'Question deleted.',
  'form.questions.delete_failed': 'Failed to delete question.',
  'form.questions.question_title': 'Question',
  'form.questions.question_text': 'Description (optional)',
  'form.questions.answers': 'Answer options',
  'form.questions.add_answer': 'Add answer',
  'form.questions.type_multiple': 'Multiple choice',
  'form.questions.type_single': 'Single choice',
  'form.questions.type_text': 'Free text',
  'form.questions.dropdown_hint': 'Display question as a dropdown.',
  'form.questions.free_text': 'Written answer',
  'form.questions.no_answers': 'No answers added yet',
  'form.questions.new_question': 'New question',
  'form.questions.edit_question': 'Edit question',
  'form.questions.delete_question': 'Delete question',
  'form.questions.delete_confirmation_1': 'Are you sure you want to delete the question: ',
  'form.questions.delete_confirmation_2': '? This action cannot be undone.',
  'form.questions.ai_prompt_required': 'Please provide a title so the AI can generate a question.',
  'form.questions.ai_generation_failed':
    "We couldn't suggest answers for this question. Try rephrasing it, for example make it shorter or more specific, and try again.",

  'publication.status.waiting': 'Waiting',
  'publication.status.success': 'Everything OK',
  'publication.status.critical': 'Critical Issue',
  'publication.status.logical': 'Logical Issue',
  'publication.status.unknown': 'Unknown',
  'publication.slot.free': 'Free Slot',
  'publication.no_results': 'No results found',
  'publication.no_results.hint': "Try adjusting your search or filter to find what you're looking for.",
  'publication.publisher_backend': 'Publisher Backend',
  'publication.last_synced': 'Last synced',
  'publication.show_more': 'Show more',
  'publication.jobiq.deactivate': '{product} deactivate',
  'publication.jobiq.activate': '{product} activate',

  'orders.create.form.ref_number': 'Reference No.',
  'orders.create.form.ref_number_help':
    'This is the reference number of the order in your system. Will be generated automatically if left empty.',
  'orders.create.form.images_empty': 'Order has no images',
  'orders.create.form.products_empty': 'Order has no products chosen',
  'orders.create.form.save_confirm': 'Save & Confirm',
  'orders.create.form.publish': 'Publish',
  'orders.create.form.publish_tooltip':
    'Synchronization blocked: one or more campaigns are missing required fields. Please complete all required data before synchronizing.',
  'orders.create.form.publish_tooltip_unconfirmed':
    'Synchronization blocked: awaiting customer confirmation before campaigns can be published.',
  'orders.create.form.publish_tooltip_linkedin':
    'Everything is ready. LinkedIn can only be synchronized if the campaign start date ({date}) is the same day as today.',
  'orders.confirmation.title': 'Please confirm your order',

  'orders.details.title': 'Order Details',
  'orders.details.clicks': 'Total Clicks',
  'orders.details.impressions': 'Total Impressions',
  'orders.details.cost_per_click': 'Cost Per-Click',
  'orders.details.cpc_waiting': 'Waiting for more data',
  'orders.details.total_cost': 'Total Cost',
  'orders.details.better_than_yesterday': 'better than yesterday',
  'orders.details.worse_than_yesterday': 'worse than yesterday',
  'orders.details.remarks.empty': 'There are no remarks for this order',
  'orders.details.previews.empty': 'There are no previews for this order',
  'orders.details.info': 'Info',
  'orders.details.channels': 'Channels',
  'orders.details.settings': 'Settings',
  'orders.details.preview': 'Preview',
  'orders.details.packages': 'Packages',
  'orders.details.support': 'Support',
  'orders.details.banners': 'Banners',
  'orders.details.banners.empty': 'No banners found for this order',
  'orders.details.banners.not_editable': 'This banner is not editable - created for you by our team',
  'orders.details.job_posting': 'Job Posting',
  'orders.details.kanban': 'Candidates',
  'orders.details.kanban.no_swimlanes': 'No swimlanes are configured for this board yet.',
  'orders.details.kanban.empty_lane': 'No candidates',
  'orders.details.kanban.has_more': 'More candidates not shown',
  'orders.details.kanban.unnamed_candidate': 'Unnamed candidate',
  'orders.details.kanban.card_detail': 'Card detail',
  'orders.details.kanban.density.s': 'S',
  'orders.details.kanban.density.m': 'M',
  'orders.details.kanban.search_placeholder': 'Search candidates…',
  'orders.details.kanban.move_error': 'Could not move candidate(s). Please try again.',
  'orders.details.kanban.load_error': 'Could not load the candidate board. Please try again.',
  'orders.details.kanban.collapse': 'Collapse',
  'orders.details.kanban.expand': 'Expand',
  'orders.details.channels.empty': 'No channels found for this order',
  'orders.details.delete_order.title': 'Delete this order?',
  'orders.details.delete_order.description':
    'Are your sure you want to delete this order? This action cannot be undone.',
  'orders.details.delete_order.error': 'Could not delete this order.',

  'orders.details.delete_campaigns': 'Delete Order',
  'orders.details.finish_campaigns': 'Finish Campaigns',
  'orders.details.finish_campaigns.description':
    "Are your sure you want to finalize this order's campaigns? This action cannot be undone.",
  'orders.details.finish_campaigns.success': 'The process to finish the campaigns has started successfully',

  'orders.details.open_directlink.tooltip': 'Open Direct Link',
  'orders.details.stats': 'Stats',
  'orders.stats.overview': 'Overview',
  'orders.stats.campaigns': 'Campaigns',
  'orders.stats.by_provider': 'By Provider',
  'orders.stats.by_campaign': 'By Campaign',
  'orders.stats.no_data': 'No statistics available yet',
  'orders.stats.avg': 'avg',
  'orders.stats.metric.clicks': 'Clicks',
  'orders.stats.metric.impressions': 'Impressions',
  'orders.stats.metric.ctr': 'CTR',
  'orders.stats.metric.reach': 'Reach',
  'orders.stats.metric.outbound_clicks': 'Outbound Clicks',
  'orders.stats.metric.conversions': 'Conversions',
  'orders.stats.metric.applications': 'Applications',
  'orders.stats.cost': 'Cost',
  'orders.stats.progress': 'Progress',
  'orders.stats.spend_of': 'Spend of',
  'orders.stats.days_left_of': '{0} days left of {1}',
  'orders.stats.clicks_incremental': 'Clicks Incremental',
  'orders.stats.provider_breakdown': 'Provider Breakdown',
  'orders.stats.metric.t10': 'Quality Clicks (T ≥ 10)',
  'orders.stats.metric.t30': 'Quality Clicks (T ≥ 30)',
  'orders.stats.metric.t60': 'Quality Clicks (T ≥ 60)',
  'orders.stats.metric.t120': 'Quality Clicks (T ≥ 120)',
  'orders.stats.finished': 'Finished',
  'orders.stats.metric_explorer': 'Metric Explorer',
  'orders.stats.explorer.provider': 'Provider',
  'orders.stats.explorer.metric': 'Metric',
  'orders.stats.explorer.view': 'View',
  'orders.stats.explorer.all_providers': 'All Providers',
  'orders.stats.explorer.daily': 'Daily',
  'orders.stats.explorer.cumulative': 'Cumulative',
  'orders.stats.explorer.compare': 'Compare',
  'orders.stats.explorer.total': 'Total',
  'orders.stats.explorer.daily_avg': 'Daily Avg',
  'orders.stats.explorer.share': 'Share',
  'orders.stats.explorer.breakdown': 'Breakdown',
  'orders.stats.explorer.no_breakdown': 'None',
  'orders.stats.breakdown.age': 'Age',
  'orders.stats.breakdown.gender': 'Gender',
  'orders.stats.breakdown.device': 'Device',
  'orders.stats.breakdown.region': 'Region',
  'orders.stats.breakdown.platform': 'Platform',
  'orders.stats.breakdown.country': 'Country',
  'orders.stats.breakdown.publisher': 'Publisher',

  'orders.preview_modal.tooltip': 'Get Preview Link',
  'orders.preview_modal.title': 'Select Ad Previews',
  'orders.preview_modal.preview_link_generated': 'Preview Link Generated!',
  'orders.preview_modal.ad_previews': 'Ad Previews',
  'orders.preview_modal.no_previews': 'No previews are available for this order.',
  'orders.preview_modal.share_instruction':
    'Choose the ad previews you want to include in a shareable public link. After selecting, click "Generate Link" to create it. You can then share the link with your customers.',
  'orders.oreview_modal.generated_link_instruction':
    'Your shareable preview link has been successfully created. You can now share this link with your customers to showcase the selected ad previews.',

  'nav.promptsuite': 'RecruitingIQ',
  'promptsuite.apps.title': '{filter} Apps',
  'promptsuite.apps.subtitle': 'Available AI Apps',
  'promptsuite.show_advanced_options': 'Show Advanced Options',
  'promptsuite.additional_user_instructions': 'Additional Instructions',
  'promptsuite.additional_user_instructions_placeholder':
    'Example: Write it so simply that a 4-year-old could understand it.',
  'promptsuite.additional_user_instructions.hint':
    'You can provide additional instructions here that the AI should follow while generating the text.',
  'promptsuite.generate': 'Generate',
  'promptsuite.sidebar.title': 'Input',
  'promptsuite.sidebar.language': 'Language',

  'promptsuite.apps.filter.all': 'All',
  'promptsuite.apps.filter.jobposting': 'Job Posting',
  'promptsuite.apps.filter.socialmedia': 'Social Media',
  'promptsuite.apps.filter.activesourcing': 'Active Sourcing',
  'promptsuite.apps.filter.interview': 'Interview',
  'promptsuite.apps.filter.personnelconsultant': 'Personaldienstleister',
  'promptsuite.apps.filter': 'Filter',
  'promptsuite.empty_hint': 'Please fill in your information in the right panel.',

  'promptsuite.welcome.title': 'Willkommen bei RecruitingIQ',
  'promptsuite.welcome.subtitle': 'Startseite',
  'promptsuite.welcome.button_to_apps': 'Direkt zu den Apps',

  'promptsuite.linkedinsearch.additional_skills': 'Additional Skills',
  'promptsuite.linkedinsearch.additional_skills.placeholder': 'Example: Salesforce, CRM, Solutionssales',

  'promptsuite.linkedinsearch.additional_tasks': 'Additional Tasks',
  'promptsuite.linkedinsearch.additional_tasks.placeholder': 'Example: Lead generation, Customer acquisition',

  'promptsuite.linkedinsearch.other_titles': 'Additional Job Titles',
  'promptsuite.linkedinsearch.other_titles.placeholder': 'Example: Sales Manager, Sales Representative',

  'promptsuite.linkedinsearch.exclude': 'Excluded Jobs, Skills, Tasks or Titles',
  'promptsuite.linkedinsearch.exclude.placeholder': 'Example: Call Center, Customer Service',

  'promptsuite.linkedinsearch.open_in_linkedin': 'Open in LinkedIn',

  'promptsuite.feedback.title': 'App Feedback',
  'promptsuite.feedback.subtitle': `Your feedback is valuable to us. If you encountered any problems with the app or the content it
  produces, please share your experience so we can enhance our service.`,
  'promptsuite.feedback.message': 'Please describe your experience...',
  'promptsuite.feedback.send': 'Send Feedback',
  'promptsuite.feedback.cancel': 'Cancel',
  'promptsuite.feedback.thank_you': 'Thank you for your feedback!',

  'eula.accept': 'Accept EULA',
  temperature: 'Temperature',
  'temperature.p1': `The temperature parameter controls the randomness or creativity of the model's output. It is a
  hyperparameter that influences the probability distribution of the tokens (words or characters)
  generated by the model.`,
  'temperature.p2': `A higher temperature value (e.g., 1.0 or above) will make the model generate more diverse and creative responses,
  but at the risk of becoming less coherent or accurate. A lower temperature value (e.g., 0.1 or below) will make the model produce more
  focused, conservative, and deterministic outputs, sticking closely to the patterns it has seen in its training data.`,
  'template.hint': `The template modifies the writing style of the job posting. Choose a template that best fits your job's
  audience for optimal results.`,

  'settings.accounts.title': 'Accounts',
  'settings.accounts.subtitle': 'Settings / Accounts',
  'settings.accounts.description': 'Create and manage your accounts',

  'settings.companies.title': 'Companies',
  'settings.companies.subtitle': 'Settings / Companies',
  'settings.companies.description': 'Create and manage your companies',
  'settings.companies.profile_tab': 'Profile',
  'settings.companies.media_tab': 'Images & Media',

  'settings.sub_budgets.title': 'Sub-Budgets',
  'settings.sub_budgets.description': 'Create and manage your sub-budgets',

  'settings.linked_networks.title': 'Linked Social Networks',
  'settings.linked_networks.description': 'Create and manage your social networks',
  'settings.swimlanes.title': 'Candidate board',
  'settings.swimlanes.subtitle': 'Create and manage your candidate board',
  'settings.swimlanes.description': 'Configure the candidate board columns for your team.',
  'settings.swimlanes.system': 'System',
  'settings.swimlanes.hidden': 'Hidden',
  'settings.swimlanes.system_locked': 'System swimlane — fixed position, cannot be renamed or removed',
  'settings.swimlanes.candidate_count': '{count} candidates',
  'settings.swimlanes.rename': 'Rename',
  'settings.swimlanes.reorder': 'Drag to reorder {name}',
  'settings.swimlanes.delete_has_candidates': 'Cannot delete a swimlane that still has candidates',
  'settings.swimlanes.add_placeholder': 'New swimlane name',
  'settings.swimlanes.add_button': 'Add swimlane',
  'settings.swimlanes.delete_title': 'Delete this swimlane?',
  'settings.swimlanes.delete_text': 'Are you sure you want to delete the "{name}" swimlane?',
  'settings.linked_networks.facebook.button': 'Link a Facebook Page',
  'settings.linked_networks.facebook.auth_modal.title': 'Linking your Facebook Pages',
  'settings.linked_networks.facebook.auth_modal.processing': 'Processing Facebook linking data...',
  'settings.linked_networks.facebook.auth_modal.pages_connected': 'Facebook Page successfully linked!',
  'settings.linked_networks.facebook.auth_modal.error':
    'There was an error linking the Facebook Page. Please try again.',
  'settings.linked_networks.no_networks': 'No linked social networks found',
  'settings.linked_networks.delete_facebook.title': 'Delete Facebook page link',
  'settings.linked_networks.delete_facebook.description':
    'Are your sure you want to delete this Facebook page link? This action cannot be undone.',
  'settings.linked_networks.facebook.note_title': 'Note',
  'settings.linked_networks.facebook.note':
    'Your pages will appear on our page 10-20 minutes after you approve the requests in your',
  'settings.linked_networks.facebook.business_settings': 'Facebook Business Settings',

  'settings.companies.error_selecting_company': 'Something went wrong while selecting the company',
  'settings.companies.error_fetching_images': 'Error fetching company images',
  'settings.companies.error_images_update_failed': 'Failed to update company images',

  'settings.company.details': 'Company Details',
  'settings.company.name': 'Company Name',
  'settings.company.name.hint': 'The full name of the company including legal form.',
  'settings.company.display_name': 'Display Name',
  'settings.company.display_name.hint': 'The name to be used for display.',
  'settings.company.hierarchy': 'Hierarchy',
  'settings.company.parent': 'Parent',
  'settings.company.parent.hint': 'Select the parent company',
  'settings.company.company_level': 'Company level',
  'settings.company.company_level.hint': 'How the current company relates to its parent company.',
  'settings.company.address': 'Company address',
  'settings.company.address.street': 'Street',
  'settings.company.address.street.hint': 'The legal address of the company.',
  'settings.company.address.city': 'City',
  'settings.company.address.city.hint': 'The city of the headquarters of the company.',
  'settings.company.web_links': 'Web & Links',
  'settings.company.web_links.homepage': 'Homepage',
  'settings.company.web_links.homepage.hint': 'The company homepage',

  'settings.company.media.upload_logo': 'Upload a company logo',
  'settings.company.media.upload_logo.hint':
    'Add your logo to personalize your company profile. Ideally, use a high-resolution PNG or SVG file.',
  'settings.company.media.company_images': 'General company images',
  'settings.company.media.company_images.hint':
    'Add images that represent your company—ideal for advertising, job postings, and your public presence.',
  'settings.company.media.brand_colours': 'Brand colours',
  'settings.company.media.brand_colours.hint': 'Used on every ad we build for this company.',

  'settings.company.orders.no_orders': 'No orders found',
  'settings.company.orders.no_orders.hint': 'You can create new orders in the Orders Page',
  'settings.company.orders.job_title': 'Job Title',
  'settings.company.orders.created_at': 'Created',

  'company.images': 'Company Images',
  'company.images.title': 'Company Images',
  'company.images.logo.title': 'Company Logo',
  'company.images.logo.subtitle': 'Optionaly, upload media for this company',
  'company.images.media.title': 'Company Media',
  'company.images.media.subtitle': 'Optionaly, upload media for this company',
  'company.images.media.success_update_message': 'Company images updated',
  'company.details': 'Company Details',
  'company.profile': 'Profile',
  'company.details.personal_details': 'Personal Details',
  'company.details.name': 'Company Name',
  'company.details.homepage': 'Company Homepage',
  'company.details.address': 'Address',
  'company.details.address_street': 'Street',
  'company.details.address_city': 'City',
  'company.details.address_zip': 'Zip Code',
  'company.details.address_country': 'Country',
  'company.create.button': 'Create Company',
  'company.save.button': 'Save Company',

  'nav.settings': 'Settings',
  'settings.title': 'Settings',
  'settings.subtitle': 'Settings / Overview',
  'settings.all_settings': 'All Settings',

  'nav.account': 'Account',
  'account.settings': 'Account Settings',
  'account.create.button': 'Create Account',

  'account.profile': 'Profile',
  'account.profile.save': 'Save Account',
  'account.profile.personal_details': 'Personal Details',
  'account.profile.firstname': 'First Name',
  'account.profile.lastname': 'Last Name',
  'account.profile.email': 'Email Address',
  'account.profile.email_help': "This is the email address you use for login, and it's how we will contact you.",
  'account.profile.phone.title': 'Phone number',
  'account.profile.phone.help': 'We use your mobile number to confirm it is really you.',
  'account.profile.phone.none': 'No phone number',
  'account.profile.phone.already_verified': 'This phone number is already verified.',
  'account.profile.admin.title': 'Admin Permission',
  'account.profile.admin.text': 'Is Admin User?',
  'account.profile.admin_help':
    'By making this account an admin, it will bypass all permission checks. Additionally, only admin accounts have the ability to edit, create, and delete other accounts.',

  'account.password': 'Password & Security',
  'account.password.password': 'Password',
  'account.password.change': 'Change Password',
  'account.password.new_field': 'New Password',
  'account.password.repeat_field': 'Repeat Password',
  'account.password.set_new': 'Set New Password',
  'account.password.passwords_need_to_match': 'The given passwords need to match.',
  'account.password.change_help': 'Please enter your new password twice to ensure there are no typos.',
  'account.password.explain': "You can change your account's password at any point in time.",

  'account.experience': 'Experience',
  'account.experience.give_feedback': 'Give Feedback',

  'order.deleted': 'The order has been deleted successfully',
  'order.image.upload_failed': 'Failed to upload image',
  'order.image.invalid_format': 'Invalid file type',
  'order.image.too_big': 'File bigger than 10MB',

  'order.status': 'Order Status',
  'order.status.draft': 'Draft',
  'order.status.to_be_confirmed': 'Unconfirmed',
  'order.status.confirmed': 'Confirmed',
  'order.status.running': 'Running',
  'order.status.waiting_to_finish': 'Finishing',
  'order.status.finished': 'Finished',

  'order.chat.no_messages': 'There are not messages yet.',

  'order.job_posting.retry_btn': 'Retry',
  'order.job_posting.retrying': 'Re-crawling initiated',
  'order.job_posting.currently_crawling': 'We are currently crawling your Job Posting.',
  'order.job_posting.could_not_crawl': 'Unable to Crawl Your Job Posting',
  'order.job_posting.could_not_crawl_text':
    'Please let us know if this issue persists. In the meantime, kindly enter the job posting manually.',
  'order.job_posting.placeholder': 'Start typing...',

  'order.job_posting.crawler_status.waiting': 'Waiting',
  'order.job_posting.crawler_status.success': 'Success',
  'order.job_posting.crawler_status.in_progress': 'In Progress',
  'order.job_posting.crawler_status.error': 'Error',
  'order.job_posting.crawler_status.blocked': 'Blocked',
  'order.job_posting.crawler_status.blocked_by_subflow': 'Blocked by Subflow',
  'order.job_posting.crawler_status.exec_canceled': 'Execution Canceled',
  'order.job_posting.crawler_status.postpone_scheduled': 'Postpone Scheduled',
  'order.job_posting.crawler_status.postponed': 'Postponed',
  'order.job_posting.crawler_status.unknown': 'Unknown Status',

  'nav.products': 'Products',
  'products.title': 'Select Products & Packages',
  'products.default': 'Default',
  'products.modal.budget.title': 'Campaign budget',
  'products.modal.duration.title': 'Duration',
  'products.modal.metric.title': 'Number of Clicks',
  'products.modal.spending.title': 'Spending limit',
  'products.modal.spending.slider.title': 'Spending limit',
  'products.modal.subscription.title': 'Subscription',
  'products.modal.subscription.confirmation': 'Do you want to add this subscription to the cart?',
  'products.modal.splits.title': 'Sub-Budget',
  'products.modal.splits.description': 'Specify from which Sub-Budget this order should be taken from.',
  'products.modal.splits.suggesting': 'Finding best match...',
  'products.modal.splits.below_minimum_error': 'The selected budget is below the minimum budget',
  'products.modal.metric.goal.title': 'Number of Clicks',
  'products.modal.options.no_selected': 'No option selected',
  'products.modal.button.continue': 'Accept & Continue',
  'nav.billing': 'Billing',
  'nav.billing.budget': 'Budget',
  'nav.billing.splits': 'Sub-Budgets',
  'nav.billing.vbudgets': 'Sub-Budgets',
  'billing.budget.no_budget': 'There is no active budget available',
  'billing.budget.title': 'Budget & Contracts',
  'billing.budget.manage_virtual_budgets': 'Manage Sub-Budgets',
  'billing.budget.remaining_card': 'Remaining Budget',
  'billing.budget.spent_of': 'spent of',
  'billing.budget.consumed': 'consumed',
  'billing.budget.allocations_card': 'Allocations / Sub-Budgets',
  'billing.budget.more_allocations': 'more allocations',
  'billing.budget.chart.no_budget': 'No budget',
  'billing.budget.allocations_card.unallocated': 'Unallocated',
  'billing.budget.allocations_card.button': 'Manage Sub-Budgets',
  'billing.budget.budget_tab.contract': 'Contract',
  'billing.budget.budget_tab.contact': 'Contact',
  'billing.budget.budget_tab.no_contact': 'No contact available',
  'billing.budget.transactions.title': 'Transactions',
  'billing.budget.transactions.everything': 'Everything',
  'billing.budget.transactions.withdrawals': 'Withdrawals',
  'billing.budget.transactions.deposits': 'Deposits',
  'billing.budget.transactions.empty': 'No transactions found',

  // Sub-Budgets
  'billing.vbudgets.title': 'Sub-Budgets',
  'billing.vbudgets.available': 'Available',
  'billing.vbudgets.unallocated': 'Unallocated',
  'billing.vbudgets.total_spent': 'Total Spent',
  'billing.vbudgets.main_budget': 'Main Budget',
  'billing.vbudgets.virtual_budget': 'Sub-Budget',
  'billing.vbudgets.create_vbudget': 'Create Sub-Budget',
  'billing.vbudgets.select_budget': 'Select a Budget',
  'billing.vbudgets.select_budget_description': 'Choose a budget from the tree to view its details',
  'billing.vbudgets.allocation': 'Allocation',
  'billing.vbudgets.spent': 'Spent',
  'billing.vbudgets.details': 'Details',
  'billing.vbudgets.description': 'Description',
  'billing.vbudgets.no_description': 'No description',
  'billing.vbudgets.allocation_type': 'Allocation Type',
  'billing.vbudgets.start_date': 'Start Date',
  'billing.vbudgets.end_date': 'End Date',
  'billing.vbudgets.budget_distribution': 'Budget Distribution',
  'billing.vbudgets.creating_under': 'Creating under',
  'billing.vbudgets.create': 'Create',
  'billing.vbudgets.form.name': 'Name',
  'billing.vbudgets.form.name_placeholder': 'Enter Sub-Budget name',
  'billing.vbudgets.form.description': 'Description',
  'billing.vbudgets.form.description_placeholder': 'Optional description',
  'billing.vbudgets.form.allocation': 'Allocation Amount',
  'billing.vbudgets.form.allocation_placeholder': 'Enter amount',
  'billing.vbudgets.form.allocation_type': 'Allocation Type',
  'billing.vbudgets.form.fixed': 'Fixed Amount',
  'billing.vbudgets.form.percentage': 'Percentage',
  'billing.vbudgets.form.start_date': 'Start Date',
  'billing.vbudgets.form.end_date': 'End Date',
  'billing.vbudgets.form.date_range': 'Date Range',
  'billing.vbudgets.form.limit_availability': 'Limit budget availability',
  'billing.vbudgets.form.select_date_range': 'Select start and end date',
  'billing.vbudgets.form.reference_channels': 'Reference Channels',
  'billing.vbudgets.auto_selection': 'Automatic Selection',
  'billing.vbudgets.auto_selection_description':
    'Orders matching these reference channels will automatically be assigned to this sub-budget.',
  'billing.vbudgets.error_loading_budget': 'Error loading active budget',
  'billing.vbudgets.error_loading_tree': 'Error loading budget tree',
  'billing.vbudgets.form_validation_error': 'Please fill in all required fields',
  'billing.vbudgets.created_successfully': 'Sub-Budget created successfully',
  'billing.vbudgets.error_saving': 'Error saving Sub-Budget',
  'billing.vbudgets.updated_successfully': 'Sub-Budget updated successfully',
  'billing.vbudgets.deleted_successfully': 'Sub-Budget deleted successfully',
  'billing.vbudgets.error_deleting': 'Error deleting Sub-Budget',
  'billing.vbudgets.delete_confirm_title': 'Delete Sub-Budget',
  'billing.vbudgets.delete_confirm_description':
    'Are you sure you want to delete this Sub-Budget? This action cannot be undone.',
  'billing.vbudgets.edit_vbudget': 'Edit Sub-Budget',
  'billing.vbudgets.empty_title': 'No Sub-Budgets Yet',
  'billing.vbudgets.empty_description': 'Sub-Budgets help you organize and track spending across teams or campaigns.',
  'billing.vbudgets.empty_cta': 'Create Your First Sub-Budget',
  'billing.vbudgets.total_budget': 'Total Budget',
  'billing.vbudgets.allocated_label': 'allocated',
  'billing.vbudgets.of_budget_used': 'of budget used',
  'billing.vbudgets.remaining_of': '{remaining} of {total} remaining',
  'billing.vbudgets.belongs_to': 'Belongs to',
  'billing.vbudgets.parent_available': 'Available in parent',
  'billing.vbudgets.create_child': 'Add Sub-Budget',
  'billing.vbudgets.col.name': 'Name',
  'billing.vbudgets.col.allocation': 'Allocation',
  'billing.vbudgets.col.spent': 'Spent',
  'billing.vbudgets.col.available': 'Available',
  'billing.vbudgets.col.usage': 'Usage',
  'billing.vbudgets.col.actions': 'Actions',
  'billing.vbudgets.sub_budgets': 'Sub-Budgets',
  'billing.vbudgets.no_sub_budgets': 'No sub-budgets created yet.',
  'billing.vbudgets.tab.details': 'Details',

  'billing.splits.title': 'Sub-Budgets',

  'time.last_month': 'Last month',
  'time.more_than_two': 'More than 2 Months ago',
  'time.more_than_six': 'More than 6 Months ago',
  'time.more_than_year': 'More than a Year ago',

  // External Job Markets
  'external_job_markets.title': 'Jobs',
  'external_job_markets.jobs_count': 'Jobs',
  'external_job_markets.last_updated': 'Updated',
  'external_job_markets.select_datapool': 'Select a job market',
  'external_job_markets.select_datapool_hint': 'Choose one of the available job markets to view jobs',
  'external_job_markets.jobs_for_datapool': 'Jobs for {name}',
  'external_job_markets.search_jobs': 'Search jobs',
  'external_job_markets.job_title': 'Job Title',
  'external_job_markets.company': 'Company',
  'external_job_markets.location': 'Location',
  'external_job_markets.workload': 'Workload',
  'external_job_markets.language': 'Language',
  'external_job_markets.expires': 'Expires',
  'external_job_markets.view_job': 'View job',
  'external_job_markets.create_order': 'Create Order',
  'external_job_markets.no_jobs': 'No jobs found',
  'external_job_markets.no_jobs_search': 'No jobs found for your search',
  'external_job_markets.no_jobs_hint': 'This job market currently has no active jobs',
  'external_job_markets.expires_soon': 'Expires soon',
  'external_job_markets.expired': 'Expired',
  'external_job_markets.no_applications': 'No Applications',
  'external_job_markets.no_hires': 'No Hires',
  'external_job_markets.not_enough_applications': 'Not Enough Applications',
  'external_job_markets.filters': 'Filters',
  'external_job_markets.freshness': 'Freshness',
  'external_job_markets.freshness.today': 'Last 24h',
  'external_job_markets.freshness.7days': 'Last 7 days',
  'external_job_markets.freshness.30days': 'Last 30 days',
  'external_job_markets.reset_filters': 'Reset filters',
  'external_job_markets.loading_jobs': 'Loading jobs...',
  'external_job_markets.job_count_info': '{filtered} of {total} jobs',
  'external_job_markets.property_filters': 'Properties',

  'common.back': 'Back',

  'channel_references.customer_account': 'Customer Account',
  'channel_references.company': 'Company',
  'channel_references.product': 'Product',
  'channel_references.search_accounts': 'Search accounts...',
  'channel_references.search_products': 'Search products...',

  'user_emails_selector.existing_user': 'Existing user',
  'user_emails_selector.insert_email': 'Insert e-mail',
  'user_emails_selector.users.placeholder': 'Select users',
  'user_emails_selector.email.placeholder': 'Type an email address',

  'candidate.detail.loading': 'Loading candidate details...',
  'candidate.detail.unnamed_candidate': 'Unnamed candidate',
  'candidate.detail.load_error': 'Could not load this candidate. Please try again.',
  'candidate.detail.not_found_title': 'Candidate not found',
  'candidate.detail.not_found_text': 'This candidate does not exist, or is not part of your account.',
  'candidate.detail.error_title': 'Could not load this candidate',
  'candidate.detail.retry': 'Try again',
  'candidate.detail.no_phone': 'No phone number provided',
  'candidate.detail.form_answers': 'Form question answers',
  'candidate.detail.no_answers': 'No form question answers recorded for this application',
  'candidate.detail.question_column': 'Question',
  'candidate.detail.answer_column': 'Answer',
  'candidate.detail.form_events': 'Activity timeline',
  'candidate.detail.no_events': 'No activity recorded for this application',
  'candidate.detail.status_history': 'Status history',
  'candidate.detail.no_status_history': 'No status changes recorded for this application',
  'candidate.detail.status_change': '{from} → {to}',
  'candidate.detail.status_created': 'Application created ({status})',
  'candidate.detail.event_form_opened': 'Opened the application form',
  'candidate.detail.event_section_viewed': 'Viewed "{section}"',
  'candidate.detail.event_section_answered': 'Answered "{section}"',
  'candidate.detail.event_section_back': 'Went back from "{section}"',
  'candidate.detail.event_files_uploaded': 'Uploaded requested files',
  'candidate.detail.applications': 'Applications',
  'candidate.detail.no_applications': "This candidate hasn't applied to any orders yet.",
  'candidate.detail.order_label': 'Order #{id}',
  'candidate.detail.publication_label': 'Publication #{id}',
  'candidate.detail.close_button': 'Close',
  'candidate.detail.discard_button': 'Discard',
  'candidate.detail.hire_button': 'Mark as Hired',
  'candidate.detail.close_title': 'Close this application?',
  'candidate.detail.close_text': 'This will move {name} to the closed lane for order #{id}.',
  'candidate.detail.close_success': 'Application closed.',
  'candidate.detail.close_error': 'Could not close this application. Please try again.',
  'candidate.detail.discard_title': 'Discard this application?',
  'candidate.detail.discard_text': "This will discard {name}'s application for order #{id}.",
  'candidate.detail.discard_success': 'Application discarded.',
  'candidate.detail.discard_error': 'Could not discard this application. Please try again.',
  'candidate.detail.discard_choice_title': 'Discard or delete {name}?',
  'candidate.detail.discard_choice_text': 'Choose how you want to remove {name} from this application.',
  'candidate.detail.discard_option_title': 'Discard application',
  'candidate.detail.discard_option_text':
    "Removes {name} from this order's pipeline for order #{id}. They remain available for other orders and in the candidate pool.",
  'candidate.detail.full_delete_option_title': 'Full delete',
  'candidate.detail.full_delete_option_text':
    "Permanently deletes {name}'s personal data and all of their applications. This cannot be undone.",
  'candidate.detail.full_delete_button': 'Full Delete',
  'candidate.detail.full_delete_success': 'Candidate permanently deleted.',
  'candidate.detail.full_delete_error': 'Could not delete this candidate. Please try again.',
  'candidate.detail.hire_title': 'Mark as hired?',
  'candidate.detail.hire_text': 'This will move {name} to the hired lane for order #{id}.',
  'candidate.detail.hire_success': 'Candidate marked as hired.',
  'candidate.detail.hire_error': 'Could not mark this candidate as hired. Please try again.',
  'candidate.detail.back_to_applications': 'Back to candidates',
  'candidate.detail.sections': 'Sections',
  'candidate.detail.contact': 'Contact',
  'candidate.detail.files': 'Files',
  'candidate.detail.messages': 'Messages',
  'candidate.detail.no_files': 'No files submitted for this application',
  'candidate.detail.file_download_error': 'Could not download this file. Please try again.',
  'candidate.detail.download_file': 'Download',
  'candidate.detail.applied_on_label': 'Applied on',
  'candidate.detail.application_label': 'Application',
  'candidate.detail.publication_label_short': 'Publication',
  'candidate.detail.show_more': 'Show more',
  'candidate.detail.show_less': 'Show less',
  'candidate.detail.contact_preference': 'Preferred contact time',
  'candidate.detail.no_contact_preference': 'No preference given',
  'candidate.detail.contact_time_morning': 'Morning',
  'candidate.detail.contact_time_midday': 'Midday',
  'candidate.detail.contact_time_afternoon': 'Afternoon',
  'candidate.detail.contact_time_evening': 'Evening',

  'candidate.fields.title': 'Additional information',
  'candidate.fields.empty': 'No additional information recorded for this candidate yet.',
  'candidate.fields.add_placeholder': 'Add or create a field…',
  'candidate.fields.add_button': 'Add field',
  'candidate.fields.edit': 'Edit',
  'candidate.fields.clear': 'Clear value',
  'candidate.fields.not_set': 'Not set',
  'candidate.fields.save_error': 'Could not save this field. Please try again.',
  'candidate.fields.load_error': 'Could not load the additional information fields.',
  'candidate.fields.date_placeholder': 'Select a date',
  'candidate.fields.select_placeholder': 'Select an option',
  'candidate.fields.invalid_number': 'Enter a number',
  'candidate.fields.type_text': 'Text',
  'candidate.fields.type_number': 'Number',
  'candidate.fields.type_date': 'Date',
  'candidate.fields.type_select': 'Selection',
  'candidate.fields.new.title': 'New field',
  'candidate.fields.new.description': 'This field becomes available for every candidate in your account.',
  'candidate.fields.new.label': 'Field name',
  'candidate.fields.new.type': 'Field type',
  'candidate.fields.new.options': 'Options',
  'candidate.fields.new.add_option': 'Add option',
  'candidate.fields.new.remove_option': 'Remove option',
  'candidate.fields.new.create_error': 'Could not create this field. Please try again.',
  'candidate.fields.new.create_button': 'Create field',

  'candidate.messaging.no_messages': 'No messages yet.',
  'candidate.messaging.send_email': 'Email',
  'candidate.messaging.send_sms': 'SMS',
  'candidate.messaging.direction_inbound': 'Candidate',
  'candidate.messaging.direction_outbound': 'You',
  'candidate.messaging.status_sent': 'Sent',
  'candidate.messaging.status_failed': 'Failed',
  'candidate.messaging.status_pending': 'Pending',
  'candidate.messaging.subject_placeholder': 'Subject (optional)',
  'candidate.messaging.body_placeholder': 'Write a message…',
  'candidate.messaging.send_button': 'Send',
  'candidate.messaging.signature_label': 'Signature',
  'candidate.messaging.refresh': 'Refresh',
  'candidate.messaging.template_placeholder': 'Template (optional)',
  'candidate.messaging.template_hint': 'The message will be generated in the language of the job posting.',
  'candidate.messaging.template_invitation_to_interview': 'Invitation to interview',
  'candidate.messaging.template_rejection': 'Rejection',
  'candidate.messaging.order_finished': 'Messaging is no longer available — this order has finished.',
  'candidate.messaging.no_contact': 'This candidate has no email address or phone number, so they cannot be contacted.',
  'candidate.messaging.replace_template_title': 'Replace your message?',
  'candidate.messaging.replace_template_text': 'The template replaces the subject and text you have written.',
  'candidate.messaging.replace_template_confirm': 'Replace',

  'candidate.file_requests.no_requests': 'No file requests yet.',
  'candidate.file_requests.request_button': 'Request a file',
  'candidate.file_requests.macro_cv': 'Create CV Upload Request',
  'candidate.file_requests.macro_reference': 'Create Reference Upload Request',
  'candidate.file_requests.macro_custom': 'Custom',
  'candidate.file_requests.status_pending': 'Pending',
  'candidate.file_requests.status_fulfilled': 'Fulfilled',
  'candidate.file_requests.status_cancelled': 'Cancelled',
  'candidate.file_requests.status_expired': 'Expired',
  'candidate.file_requests.resend_button': 'Resend',
  'candidate.file_requests.created_at': 'Requested {date}',
  'candidate.file_requests.unnamed_file': 'Unnamed file',
  'candidate.file_requests.show_more': 'Show {count} more',
  'candidate.file_requests.custom_message_placeholder': 'Describe what you need…',
  'candidate.file_requests.cancel_form': 'Cancel',
  'candidate.file_requests.submit_button': 'Send request',
  'candidate.file_requests.pending_exists': 'A request of this type is already pending.',
  'candidate.file_requests.resend_success': 'File request resent successfully.',
  'candidate.file_requests.cancel_button': 'Cancel request',
  'candidate.file_requests.refresh': 'Refresh',

  'settings.candidate_fields.title': 'Candidate fields',
  'settings.candidate_fields.subtitle': 'Create and manage candidate information fields',
  'settings.candidate_fields.description': 'Define the additional information your team records on candidates.',
  'settings.candidate_fields.add_button': 'Add field',
  'settings.candidate_fields.edit_title': 'Edit field',
  'settings.candidate_fields.usage_count': 'Used on {count} candidates',
  'settings.candidate_fields.type_locked': 'The type cannot be changed once the field has been created',
  'settings.candidate_fields.delete_title': 'Delete this field?',
  'settings.candidate_fields.delete_text':
    'Are you sure you want to delete "{name}"? Values already recorded on candidates will be hidden.',
  'settings.candidate_fields.empty': 'No candidate fields defined yet.',

  // form controls
  'form.password.show': 'Show password',
  'form.password.hide': 'Hide password',

  // self-registration wizard
  'registration.steps.account': 'Create account',
  'registration.steps.verify_email': 'Verify email',
  'registration.steps.profile': 'Your profile',
  'registration.steps.company': 'Company details',
  'registration.steps.goal': 'Your goal',
  'registration.steps.package': 'Choose a package',
  'registration.steps.done': 'All set',
  'registration.notes.account': 'Takes about a minute.',
  'registration.notes.verify_email': 'The code lands within a few seconds.',
  'registration.notes.company': 'Only the company name is needed to start.',
  'registration.notes.goal': 'Shapes what we recommend, never binding.',
  'registration.notes.package': "This choice can't be changed later.",
  'registration.breadcrumb.step': 'Step {current} of {total} · {label}',
  'registration.breadcrumb.complete': 'Setup complete',
  'registration.footer.create_account': 'Create account',
  'registration.footer.continue': 'Continue',
  'registration.footer.finish_setup': 'Finish setup',
  'registration.sidebar.title': 'Ready for your first campaign in minutes',
  'registration.sidebar.subtitle': 'You set up your account yourself. No sales call, no waiting.',
  'registration.sidebar.now': 'now',
  'registration.support.name': 'Questions? Sami helps.',
  'registration.header.have_account': 'Already have an account?',
  'registration.footer.back': 'Back',
  'registration.footer.do_this_later': 'Do this later',
  'registration.step_placeholder': 'This step is being built.',
  // step 1 - create account
  'registration.account.title': 'Create your account',
  'registration.account.lede': 'Free to set up. You only pay per campaign, from CHF 795.\u2013 per role.',
  'registration.account.email': 'Work email',
  'registration.account.email_hint': 'We send the confirmation code here in the next step.',
  'registration.account.email_invalid': 'That does not look like an email address.',
  'registration.account.mobile': 'Mobile number',
  'registration.account.mobile_hint': 'Used to confirm your profile and to recover your account.',
  'registration.account.mobile_invalid': 'Enter the mobile number we can reach you on.',
  'registration.account.mobile_placeholder': '+41 79 123 45 67',
  'registration.account.mobile_unreadable': 'Enter your mobile number with the country code, e.g. +41 79 123 45 67.',
  'registration.account.password': 'Password',
  'registration.account.password_invalid': 'Use at least 8 characters, an uppercase letter, and a number or symbol.',
  'registration.account.terms_before': 'I agree to the',
  'registration.account.terms': 'Terms of Service',
  'registration.account.terms_between': 'and the',
  'registration.account.privacy': 'Privacy Policy',
  'registration.account.terms_after': '.',
  'registration.account.sign_in': 'Sign in',
  'registration.account.or': 'or',
  'registration.account.reset_password': 'reset your password',
  'registration.account.email_verified_by': 'Verified by {provider}.',
  'registration.account.use_different_email': 'Use a different email',
  'registration.account.conflict.email_already_registered': 'This address already has an account.',
  'registration.account.conflict.registration_in_progress': 'You already started registering with this address.',

  // "set your password" screen mid-registration, reached from the reset-password link
  'registration.set_password.breadcrumb': 'Set your password',
  'registration.set_password.title': 'Set a new password',
  'registration.set_password.lede':
    'Choose a password to sign back in with. You can pick up your registration right after.',
  'registration.set_password.new_password': 'New password',
  'registration.set_password.confirm_password': 'Confirm password',
  'registration.set_password.mismatch': 'The passwords do not match.',
  'registration.set_password.submit': 'Set password and continue',

  // the backend's password rule
  'registration.password.rule': 'At least 8 characters, an uppercase letter, and a number or symbol.',
  'registration.password.too_short': 'Too short',
  'registration.password.needs_length': 'Use at least 8 characters',
  'registration.password.weak': 'Weak',
  'registration.password.needs_uppercase': 'Add an uppercase letter',
  'registration.password.almost': 'Almost there',
  'registration.password.needs_number': 'Add a number or symbol',
  'registration.password.strong': 'Strong password',

  // code entry shared by the email and mobile screens
  'registration.code.paste_works': 'Pasting the whole code works',
  'registration.code.resend_in': 'Resend in {time}',
  'registration.code.resend': 'Resend the code',
  'registration.code.resending': 'Sending\u2026',

  // step 2 - verify email
  'registration.verify.title': 'Confirm your email',
  'registration.verify.lede_before': 'We sent a 6-digit code to',
  'registration.verify.lede_after': '. It expires in {minutes} minutes.',
  'registration.verify.code_label': 'Confirmation code',
  'registration.verify.no_email': 'Nothing in your inbox?',
  'registration.verify.check_spam_before': 'Check spam, or',
  'registration.verify.different_address': 'use a different address',
  'registration.verify.check_spam_after': '. Corporate filters sometimes hold the first message.',
  'registration.verify.error_incorrect': 'That code is not correct. Check the email and try again.',
  'registration.verify.error_expired': 'That code has expired. Ask for a new one.',
  'registration.verify.error_too_many': 'Too many attempts on this code. Ask for a new one.',
  'registration.verify.error_throttled': 'A code was just sent. Wait for the countdown before asking again.',

  // step 3 - your profile
  'registration.profile.title': 'Your profile',
  'registration.profile.lede': 'Applicants see the name and photo of whoever owns the role.',
  'registration.profile.first_name': 'First name',
  'registration.profile.last_name': 'Last name',
  'registration.profile.job_title': 'Job title (Optional)',
  'registration.profile.name_required': 'Your name is needed before you can continue.',
  'registration.profile.language': 'Preferred language',
  'registration.profile.mobile_title': 'Confirm your mobile number',
  'registration.profile.mobile_correct': 'Mobile number',
  'registration.profile.mobile_pending': 'Pending',
  'registration.profile.mobile_required': 'Confirm your mobile number to continue.',
  'registration.profile.mobile_verified': 'Verified',
  'registration.profile.mobile_sent_to': "We'll send a code to",
  'registration.profile.mobile_change': 'change number',
  'registration.profile.mobile_save': 'Save',
  'registration.profile.mobile_cancel': 'Cancel',
  'registration.profile.mobile_didnt_get': 'Didn\u2019t get the text?',
  'registration.profile.mobile_resend': 'Resend',
  'registration.profile.mobile_send': 'Send',
  'registration.profile.mobile_sending': 'Sending\u2026',
  'registration.profile.mobile_or': 'or',
  'registration.profile.mobile_call': 'call me with the code',
  'registration.profile.mobile_calling': 'Calling\u2026',
  'registration.profile.code_label': 'Confirmation code',
  'registration.profile.mobile_error_incorrect': 'That code is not correct. Check the SMS and try again.',
  'registration.profile.mobile_error_invalid_phone': 'That mobile number is not valid.',
  'registration.profile.mobile_error_delivery_unavailable':
    "We can't send a code to this number right now. Try another number or contact support.",
  'registration.profile.mobile_error_generic': 'Something went wrong. Please try again.',

  // step 4 - company details
  'registration.company.title': 'Company details',
  'registration.company.lede': 'This is what appears on your ads and on your invoices.',
  'registration.company.section_basics': 'The basics',
  'registration.company.section_address': 'Address and billing',
  'registration.company.section_brand': 'Brand',
  'registration.company.section_brand_hint': 'Used on every ad we build for you. You can change it later.',
  'registration.company.name': 'Company name',
  'registration.company.careers_page': 'Careers page',
  'registration.company.careers_page_hint': 'We link your ads back here.',
  'registration.company.industry': 'Industry',
  'registration.company.industry_placeholder': 'Search industry…',
  'registration.company.industry.health': 'Health and social care',
  'registration.company.industry.trades': 'Construction and trades',
  'registration.company.industry.it': 'IT and engineering',
  'registration.company.industry.retail': 'Retail and hospitality',
  'registration.company.industry.finance': 'Banking and insurance',
  'registration.company.industry.public': 'Public sector',
  'registration.company.size': 'Company size',
  'registration.company.size_placeholder': 'Search company size…',
  'registration.company.size.10': '1–10 employees',
  'registration.company.size.50': '11–50 employees',
  'registration.company.size.200': '51–250 employees',
  'registration.company.size.1000': '251–1000 employees',
  'registration.company.size.1001': 'More than 1000',
  'registration.company.street': 'Street and number',
  'registration.company.postcode': 'Postcode',
  'registration.company.city': 'City',
  'registration.company.invoice_email': 'Invoice email',
  'registration.company.uid': 'UID',
  'registration.company.field_required': 'This field is required.',
  'registration.company.uid_hint': 'e.g. CHE-123.456.789, or with MWST/TVA/IVA if you have one',
  'registration.company.uid_checking': 'Checking…',
  'registration.company.uid_confirmed': 'Confirmed: {name}',
  'registration.company.uid_invalid': 'Enter a valid Swiss UID (e.g. CHE-123.456.789).',
  'registration.company.uid_check_unavailable': "We couldn't check this — it will be reviewed. You can continue.",
  'registration.company.address_replace_title': 'Use the registered address?',
  'registration.company.address_replace_description':
    "We found this address in the Swiss commercial registry: {address}. Replace what you've entered with it?",
  'registration.company.address_replace_confirm': 'Replace address',
  'registration.company.same_address': 'Billing address is the same as the company address',
  'registration.company.billing_street': 'Billing street and number',
  'registration.company.billing_postcode': 'Billing postcode',
  'registration.company.billing_city': 'Billing city',
  'registration.company.logo': 'Logo',
  'registration.company.logo_drop': 'Drop a file',
  'registration.company.logo_replace': 'Replace the file',
  'registration.company.logo_limit': 'SVG, PNG or WebP, max 2 MB',
  'registration.company.logo_uploading': 'Uploading…',
  'registration.company.logo_error_type': 'The logo has to be an SVG, PNG or WebP.',
  'registration.company.logo_error_size': 'The logo has to be smaller than 2 MB.',
  'registration.company.logo_error_svg': 'The SVG file is invalid or corrupted.',
  'registration.company.logo_error_upload': 'The logo could not be uploaded. Try again.',

  // step 5 - your goal
  'registration.goal.title': 'What are you hiring for?',
  'registration.goal.lede': 'This shapes the channels we suggest and the budget we recommend. Nothing here is binding.',
  'registration.goal.main_goal': 'Your main goal',
  'registration.goal.main_goal.hard': 'Fill a hard-to-fill role',
  'registration.goal.main_goal.hard_description': "Nursing, trades, IT: the applications aren't coming in.",
  'registration.goal.main_goal.volume': 'Hire at volume',
  'registration.goal.main_goal.volume_description': 'Several openings of the same profile, all year.',
  'registration.goal.main_goal.brand': 'Be visible as an employer',
  'registration.goal.main_goal.brand_description': 'Stay present with candidates before they start looking.',
  'registration.goal.roles_per_year': 'Roles you expect to advertise per year',
  'registration.goal.roles_per_year_placeholder': 'Select roles per year…',
  'registration.goal.roles_per_year.3': '1–3 roles',
  'registration.goal.roles_per_year.12': '4–15 roles',
  'registration.goal.roles_per_year.40': '16–50 roles',
  'registration.goal.roles_per_year.100': 'More than 50',
  'registration.goal.start_window': 'When does the first one need to be live?',
  'registration.goal.start_window_placeholder': 'Select a start window…',
  'registration.goal.start_window.now': 'As soon as possible',
  'registration.goal.start_window.week': 'Within a week',
  'registration.goal.start_window.month': 'This month',
  'registration.goal.start_window.later': 'Just looking around',

  // step 6 - choose a package
  'registration.package.title': 'How do you want to run campaigns?',
  'registration.package.lede':
    'Same reach either way. The difference is who does the work, how fast an ad goes live, and who sets the budget.',
  'registration.package.note': "This sets how every campaign runs. You can't change it later.",
  'registration.package.managed.title': '{product} runs it for you',
  'registration.package.managed.description':
    'You brief the role in under a minute. We write the ads, choose the channels, and optimise while the campaign runs.',
  'registration.package.managed.price': 'from CHF 795.– per role',
  'registration.package.managed.price_note': 'no monthly fee',
  'registration.package.managed.pill': 'Most chosen',
  'registration.package.managed.benefit_1': 'Order placed in about a minute',
  'registration.package.managed.benefit_2': 'Copy, creatives and targeting done for you',
  'registration.package.managed.benefit_3': 'No marketing know-how needed',
  'registration.package.managed.tradeoff': 'Up to 24 hours until the campaign is live',
  'registration.package.self.title': 'You steer the campaign',
  'registration.package.self.description':
    "Set targeting and budget yourself, adjust the ads in the editor, and publish the moment you're happy. You decide what a role is worth spending.",
  'registration.package.self.price': 'from CHF 290.– per order',
  'registration.package.self.price_note': 'budget is yours to set',
  'registration.package.self.benefit_1': 'Publish instantly, live in minutes',
  'registration.package.self.benefit_2': 'Full control over channels and targeting',
  'registration.package.self.benefit_3': 'Change a live ad whenever you want',
  'registration.package.self.tradeoff': 'You write and maintain the ads yourself',

  // step 7 - all set
  'registration.done.title': 'Your account is ready, {name}',
  'registration.done.lede': '{company} is set up. Next stop: your first role.',
  'registration.done.summary_account': 'Account',
  'registration.done.summary_package': 'Campaign mode',
  'registration.done.summary_goal': 'Hiring goal',
  'registration.done.summary_goal_not_set': 'Not set yet',
  'registration.done.cta_create_campaign': 'Create my first campaign',
  'registration.done.cta_dashboard': 'Go to the dashboard',
  'registration.done.retry': 'Try again',

  // shown instead of a step when the registration is already finished elsewhere
  'registration.finished_elsewhere.title': "You're already set up",
  'registration.finished_elsewhere.lede':
    "This registration was already completed - in another tab, or on an earlier visit. There's nothing left to do here.",
  'registration.finished_elsewhere.cta': 'Go to the dashboard',

  'settings.signature.title': 'Signature',
  'settings.signature.subtitle': 'Manage your message signature',
  'settings.signature.description': 'Your signature is automatically appended to outgoing email and SMS messages.',
  'settings.signature.email_label': 'Email signature',
  'settings.signature.email_hint': 'Appended to the bottom of every email you send to candidates.',
  'settings.signature.email_placeholder': 'e.g. Best regards,\nYour Name\nYour Company',
  'settings.signature.sms_label': 'SMS signature',
  'settings.signature.sms_hint': 'Appended to the bottom of every SMS you send to candidates.',
  'settings.signature.sms_placeholder': 'e.g. – Your Name, Your Company',
  'settings.signature.sms_length': '{count} / {max} characters',
  'settings.signature.save': 'Save signature',
  'settings.signature.save_success': 'Signature saved.',

  'candidate.public.error_generic': 'Something went wrong. Please try again later.',

  'candidate.public_upload.title': 'Upload files',
  'candidate.public_upload.intro':
    '{company} has requested some additional information from you. Thank you for your interest in our job opening.',
  'candidate.public_upload.intro_no_company':
    'Some additional information has been requested from you. Thank you for your interest in our job opening.',
  'candidate.public_upload.request_cv': 'Please upload your CV.',
  'candidate.public_upload.request_reference': 'Please upload your reference letters.',
  'candidate.public_upload.request_custom': 'Please upload the requested files.',
  'candidate.public_upload.drop_hint': 'Drop files here or click to browse',
  'candidate.public_upload.constraints': 'PDF, Word (.docx), JPG or PNG · max. {size} MB each · up to {count} files',
  'candidate.public_upload.remove_file': 'Remove {name}',
  'candidate.public_upload.submit': 'Submit',
  'candidate.public_upload.submit_count': 'Submit {count} files',
  'candidate.public_upload.success_title': 'Thank you!',
  'candidate.public_upload.success_text': 'Your files have been received.',
  'candidate.public_upload.fulfilled_title': 'Files already received',
  'candidate.public_upload.fulfilled_text': 'Files have already been uploaded through this link.',
  'candidate.public_upload.cancelled_title': 'This upload request has been withdrawn.',
  'candidate.public_upload.expired_title': 'This upload link has expired.',
  'candidate.public_upload.error_invalid': 'This upload link is invalid or has expired.',
  'candidate.public_upload.error_duplicate': '"{name}" is already in the list.',
  'candidate.public_upload.error_too_many': 'You can upload at most {count} files.',
  'candidate.public_upload.error_too_large': '"{name}" is larger than {size} MB.',
  'candidate.public_upload.error_type':
    '"{name}" is not an accepted file type. Please use a PDF, Word (.docx), JPG or PNG file.',
  'candidate.public_upload.upload_failed': 'The upload failed. Please try again.',
  'candidate.public_upload.order_finished': 'This job opening has closed, so files can no longer be uploaded.',

  'candidate.public_chat.title': 'Your conversation',
  'candidate.public_chat.title_company': 'Your conversation with {company}',
  'candidate.public_chat.intro': 'Read the messages from {company} and reply below.',
  'candidate.public_chat.intro_no_company': 'Read the messages about the job opening and reply below.',
  'candidate.public_chat.reply_label': 'Your reply',
  'candidate.public_chat.no_messages': 'No messages yet.',
  'candidate.public_chat.reply_placeholder': 'Write your reply…',
  'candidate.public_chat.send': 'Send reply',
  'candidate.public_chat.reply_error': 'Your reply could not be sent. Please try again.',
  'candidate.public_chat.error_invalid': 'This conversation link is invalid or has expired.',
  'candidate.public_chat.order_finished': 'This job opening has closed, so the conversation is no longer available.',
};
